export class MonthlyPresenceSearchRequest {

    _constructionId = undefined; // boolean
    _year = undefined; // number
    _month = undefined; // number
    _companyId = undefined; // number
    _term = undefined; // string

    setConstructionId(constructionId) {
        this._constructionId = constructionId;
    }

    setYear(year) {
        this._year = year;
    }

    setMonth(month) {
        this._month = month;
    }

    setCompanyId(companyId) {
        this._companyId = companyId;
    }

    setTerm(term) {
        this._term = term;
    }

    body() {
        return {
            criteria: {
                year: this._year,
                term: this._term,
                month: this._month,
                company_id: this._companyId,
                construction_id: this._constructionId,
                companies_only_active: true,
                date: undefined,
                page: undefined,
                limit: undefined,
                worker_id: undefined,
                skip_pagination: true,
                retrieve_worker_documentation_state: undefined,
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/webservices/monthly-presence-search/MonthlyPresenceSearchRequest.js